import { FormStore } from '@roc/feature-app-core';

const form = {
  fields: {
    pointOfContactId: {
      value: '',
      error: null,
      rule: '',
    },
    firstName: {
      value: '',
      error: null,
      rule: [{ required_unless: ['drawSubType', 'soft costs'] }],
      message: 'First Name is a required field.',
    },
    lastName: {
      value: '',
      error: null,
      rule: [{ required_unless: ['drawSubType', 'soft costs'] }],
      message: 'Last Name is a required field.',
    },
    phone: {
      value: '',
      error: null,
      rule: [{ required_unless: ['drawSubType', 'soft costs'] }],
      message: 'Phone Number is a required field.',
    },
    email: {
      value: '',
      error: null,
      rule: [{ required_unless: ['drawSubType', 'soft costs'] }],
      message: 'Email is a required field.',
    },
    comments: {
      value: '',
      error: null,
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class PointOfContactFormStore extends FormStore {
  constructor(globalStore) {
    super({ ...form }, globalStore);
  }

  resetStore() {
    this.reset();
    this.form.fields.firstName.value = '';
    this.form.fields.lastName.value = '';
    this.form.fields.email.value = '';
    this.form.fields.phone.value = '';
    this.form.fields.comments.value = '';
  }
}
